import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch  } from 'react-redux';
import { REPORTS } from "../helpers/data_helper";
import { postDataAPI } from "../helpers/phpbackend_helper";
import { fetchMyDashboardData } from "../store/reports/action";
import analyticsGroupdata from "./analyticsGroupMenuData.json";

const Navdata = () => {
    const history = useHistory();
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');
    //console.log(iscurrentState);
    const [menuItems, setMenuItems] = useState([]);

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }
    
    const dispatch = useDispatch();
    const dashboardData = useSelector((state) => {
        return state.MyDashboardReducer?.dashboardData || [];
    });
    useEffect(() => {
        dispatch(fetchMyDashboardData());
    }, [dispatch]);
    //const [dashboardData, setDashboardData] = useState([]);
    // useEffect(() => {
    //     postDataAPI({
    //         serviceName: REPORTS.serviceName,
    //         op: REPORTS.op_dashboard_report,
    //     }).then((response) => {          
    //         if (response.status === "ok") {
    //             setDashboardData(response.data.result.data);
    //         } else {
    //             console.log(response);
    //         }
    //     });
    // }, []);

    let { userMenu } = useSelector(state => ({
        userMenu: state.UserOutletGroup.userMenu,
    }));

    const analyticsGroup = localStorage.getItem('analyticsGroup');
    

    useEffect(() => {
        if (analyticsGroup) {
            userMenu = analyticsGroupdata;
        } else if (userMenu!= undefined && userMenu.length>0) {
            userMenu = userMenu.filter(item => item.right_key !== "restaurant-analytics");
        }

        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Admin') {
            setIsAdmin(false);
        }
        let customMenuItem=[{
            label: "Menu",
            isHeader: true,
        }];
       if(userMenu!= undefined && userMenu.length>0){
            userMenu.map(function(menu){
            if(menu.right_parent==0){
                let meniItem={
                    id: menu.right_key,
                    label: menu.right_name,
                    icon: menu.icon??"ri-dashboard-2-line",
                    link: menu.file_name,
                };
                let subMenu=userMenu.filter(submenu => submenu.right_parent==menu.right_id);
                if(subMenu.length>0){
                    meniItem.link='/#';
                    meniItem.click=function (e) {
                        e.preventDefault();
                        setIsAdmin(!isAdmin);
                        setIscurrentState(meniItem.label);
                        updateIconSidebar(e);
                    };
                    meniItem.subItems=[];
                    meniItem.stateVariables=iscurrentState==meniItem.label;
                    subMenu.map(function(smenu){
                        meniItem.subItems.push({
                            id: smenu.right_key,
                            label: smenu.right_name,
                            link: smenu.file_name,
                            parentId: menu.right_key,
                        })
                    });
                }else{
                    meniItem.click=function (e) {
                        setIscurrentState(meniItem.label);
                    };
                }
                customMenuItem.push(meniItem);
            }
          });
       }
           
        if (dashboardData.length>0 && !analyticsGroup) {
        let mydashboardItem={
                id: "mydashboard",
                label: "My Dashboard",
                icon: "ri-dashboard-2-line",
            };
            mydashboardItem.link='/#';
            mydashboardItem.stateVariables=iscurrentState=="My Dashboard";
            mydashboardItem.click=function (e) {
                e.preventDefault();
                setIsAdmin(!isAdmin);
                setIscurrentState("My Dashboard");
                updateIconSidebar(e);
            };
            mydashboardItem.subItems=[];
            dashboardData.map(function(smenu){
                mydashboardItem.subItems.push({
                    id: "mydashboard"+smenu.export_r_id,
                    label: smenu.title,
                    link: "/my-dashboard/"+smenu.export_r_id,
                    parentId: "mydashboard",
                })
            });
            customMenuItem.push(mydashboardItem);
        }

       setMenuItems(customMenuItem);
    }, [
        history,
        iscurrentState,
        isDashboard,
        isAdmin,
        isAuth,
        userMenu,
        dashboardData,
        analyticsGroup
    ]);
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;